import React from 'react'
import UserAvatar from './UI/UserAvatar'

const UserCard = ({ user, actions, subtitle }) => {
  const displayName = user?.profileSettings?.raveName || user?.username || 'User'

  return (
    <div className="flex items-center gap-4 p-4 bg-white/5 rounded-xl border border-white/10">
      <UserAvatar user={user} size="w-12 h-12" />
      <div className="flex-1">
        <h3 className="text-white font-semibold">@{displayName}</h3>
        {subtitle && (
          <p className="text-gray-300 text-sm mt-1">{subtitle}</p>
        )}
      </div>
      <div className="flex gap-2">
        {actions}
      </div>
    </div>
  )
}

export default UserCard